import Components from "../components";
import moment from 'moment';
import * as Turbo from "@hotwired/turbo"

class DaterangePicker extends Components.Base {
  initialize() {
    this.form = this.$el.parents('form');
    this.valueFormat = this.$el.data('value-format') || 'YYYY-MM-DD';

    const options = {
      format: this.$el.data('format') || 'MMMM DD, YYYY',
      startDate: this.$el.data('start') || moment().subtract(7, 'days'),
      endDate: this.$el.data('stop') || moment().subtract(0, 'days'),
      minDate: this.$el.data('min') || moment().subtract(30, 'days'),
      maxDate: this.$el.data('max') || moment().subtract(0, 'days'),
      opens: 'left',
      ranges: {
        'Month to Date': [
          moment().startOf('month'),
          moment().subtract(0, 'days'),
        ],
        'Last 7 Days': [
          moment().subtract(6, 'days'),
          moment().subtract(0, 'days'),
        ],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      },
    };

    this.$el.daterangepicker(options, (...args) => this.setDateRange(...args));
  }

  setDateRange(start, stop) {
    const formattedStart = start.format(this.valueFormat);
    const formattedStop = stop.format(this.valueFormat);
    if (this.form.length) {
      this.form.find('[name=start]').val(formattedStart);
      this.form.find('[name=stop]').val(formattedStop);
      this.form[0].requestSubmit();
    } else {
      Turbo.visit(
        `${document.location.pathname}?start=${formattedStart}&stop=${formattedStop}`,
      );
    }
  }

  deinitialize() {
    $('body > .daterangepicker').remove(); // Remove the element that the picker adds to body
  }
}

Components.collection.register({
  selector: '.daterange',
  klass: DaterangePicker,
});
